/*=================================================;
/* PRODUCT GALLERY SLIDER
/*================================================= */
function productGallery(context) {
    const gallery = context || document;
    const product_thumbnails = gallery.querySelector('.js-product-thumbnails');

    if (product_thumbnails == null) {
       return false;
    }
 
    const product_gallery_display = gallery.querySelector('.js-product-image');

    if (product_gallery_display == null) {
       return false;
    }

    // A variation gallery replaces the complete gallery DOM. Avoid retaining
    // stale Swiper instances when a third-party integration initializes it too.
    if (product_thumbnails.swiper) {
       product_thumbnails.swiper.destroy(true, true);
    }

    if (product_gallery_display.swiper) {
       product_gallery_display.swiper.destroy(true, true);
    }

    const product_gallery_thumbnails = new Swiper(product_thumbnails, {
       centerInsufficientSlides: product_thumbnails.getAttribute('data-position') === '1',
       direction: 'horizontal',
       spaceBetween: 10,
       navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
       },
       breakpoints: {
          0: {
             direction: 'horizontal',
             slidesPerView: 5,
             centerInsufficientSlides: true,
          },
          992: {
             direction: product_thumbnails.getAttribute('data-direction'),
             slidesPerView: product_thumbnails.getAttribute('data-direction') == 'horizontal' ? 7 : 5,
          },
       },
    });
 
    const product_gallery_dislay = new Swiper(product_gallery_display, {
       spaceBetween: 10,
       pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
       },
    });
 
    // highlight first thumbnail on load
    product_gallery_thumbnails.slides[0].classList.add('swiper-slide-thumb-active');
 
    // sync thumbnails active state and scroll position when display slide changes
    product_gallery_dislay.on('slideChange', function () {
       const slides = product_gallery_thumbnails.slides;
       let i;
 
       for (i = 0; i < slides.length; i++) {
          slides[i].classList.remove('swiper-slide-thumb-active');
       }
 
       slides[product_gallery_dislay.activeIndex].classList.add('swiper-slide-thumb-active');
       product_gallery_thumbnails.slideTo(product_gallery_dislay.activeIndex, 300);
    });
 
    // navigate display slider straight to the clicked thumbnail
    product_gallery_thumbnails.slides.forEach(function (slide, index) {
       slide.addEventListener('click', function (event) {
          const link = event.target.closest ? event.target.closest('a') : null;
 
          if (link !== null) {
             event.preventDefault();
          }
 
          product_gallery_dislay.slideTo(index, 300);
          product_gallery_thumbnails.slideTo(index, 300);
       });
    });
 
 }
 productGallery();

/*=================================================;
/* WOOCOMMERCE GALLERY LIFECYCLE
/*================================================= */
// WooCommerce replaces the full gallery for variation-specific galleries.
// Reinitialize the theme's Swipers after the new markup is mounted.
jQuery(document).on('wc-product-gallery-after-init', '.woocommerce-product-gallery', function () {
   productGallery(this);
});

// Both a variation image update and a full gallery replacement must start at
// the first slide.
jQuery(document).on('woocommerce_gallery_reset_slide_position', '.woocommerce-product-gallery', function () {
   const product_thumbnails = this.querySelector('.js-product-thumbnails');
   const product_gallery_display = this.querySelector('.js-product-image');

   if (product_thumbnails && product_thumbnails.swiper) {
      product_thumbnails.swiper.slideTo(0, 300);
   }

   if (product_gallery_display && product_gallery_display.swiper) {
      product_gallery_display.swiper.slideTo(0, 300);
   }
});
 
 /*=================================================;
 /* PRODUCT STICKY
 /*================================================= */
 /**
  * Floating sticky product action if windows scroling down
  */
 function productSticky() {
    const body = document.querySelector('body');
    const element = document.querySelector('.js-sticky-product');
    const trigger = document.querySelector('.rt-product-summary form .button');
 
    if (element == null) {
       return false;
    }

    const buttons = Array.from(element.querySelectorAll('.rt-sticky-product__action .rt-btn')).filter(function (button) {
       return button.getClientRects().length > 0;
    });
    element.classList.toggle('has-two-buttons', buttons.length === 2);
 
    let position = 500;
 
    if (trigger !== null) {
       position = trigger.offsetTop + 400;
    }
 
    if (document.body.scrollTop > position || document.documentElement.scrollTop > position) {
       element.classList.add('is-sticky');
       body.classList.add('sticky-product');
    } else {
       element.classList.remove('is-sticky');
       body.classList.remove('sticky-product');
    }
 }
 window.addEventListener('scroll', productSticky);
 window.addEventListener('load', productSticky);
 window.addEventListener('resize', productSticky);
